module.exports = __webpack_public_path__ + "img/cp7_03.08cd07dd.png";